// extracted by mini-css-extract-plugin
export default {"editBtn":"EditRegionalCalendarButton_editBtn__evQtP"};